const getQuestionnaireQuestionIdentifier = question => {
    if (question.isCustom) {
        return `CUSTOM_QUESTION_${question.id}`;
    }

    return `QUESTION_${question.id}`;
};

export default getQuestionnaireQuestionIdentifier;
